import { FunctionComponent } from 'react';
import { Box, useMediaQuery } from '@material-ui/core';
import { makeStyles, createStyles, useTheme } from '@material-ui/core/styles';
import ToolbarButton from 'components/UI/Toolbar/ToolbarButton';
import { ToolbarItem } from 'components/UI/Toolbar/ToolbarItem';
import { faPencil } from '@fortawesome/pro-light-svg-icons';
import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons';
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';

interface Props {
    className?: string;
    item?: string;
    onClickMobile: () => void;
    onEdit: () => void;
    onDeleteAppointment: () => void;
}

const useStyles = makeStyles(() =>
    createStyles({
        container: {
            position: 'relative',
            display: 'flex'
        },
        icon: {
            cursor: 'pointer'
        }
    })
);

export const ServiceOptions: FunctionComponent<Props> = props => {
    const classes = useStyles();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const editOption = (
        <ToolbarItem
            icon={faPencil}
            text={`Edit ${props.item}`}
            color="#222222"
            onClick={props.onEdit}
        />
    );

    const deleteOption = (
        <ToolbarItem
            icon={faTrashAlt}
            text="Delete"
            color="#EF4F57"
            onClick={props.onDeleteAppointment}
        />
    );

    const handleClickMobile = (e: any) => {
        e.stopPropagation();
        if (isMobile) {
            props.onClickMobile();
        }
    };

    return (
        <Box
            className={clsx(props.className, classes.container)}
            onClick={handleClickMobile}
        >
            {isMobile ? (
                <FontAwesomeIcon
                    color="#000000"
                    icon={faEllipsisH}
                    className={classes.icon}
                />
            ) : (
                <ToolbarButton id="create_booking_options">
                    {editOption}
                    {deleteOption}
                </ToolbarButton>
            )}
        </Box>
    );
};

export default ServiceOptions;
